import { render, staticRenderFns } from "./AccountPassword.vue?vue&type=template&id=5472fd9a&scoped=true&"
import script from "./AccountPassword.vue?vue&type=script&lang=ts&"
export * from "./AccountPassword.vue?vue&type=script&lang=ts&"
import style0 from "./AccountPassword.vue?vue&type=style&index=0&id=5472fd9a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472fd9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5472fd9a')) {
      api.createRecord('5472fd9a', component.options)
    } else {
      api.reload('5472fd9a', component.options)
    }
    module.hot.accept("./AccountPassword.vue?vue&type=template&id=5472fd9a&scoped=true&", function () {
      api.rerender('5472fd9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/password/AccountPassword.vue"
export default component.exports